"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorCodeTranslationMap = exports.ErrorCode = void 0;
var _TranslationKey = require("../models/TranslationKey");
let ErrorCode = exports.ErrorCode = /*#__PURE__*/function (ErrorCode) {
  ErrorCode["deliveryChannelIsNotAllowedForACustomer"] = "200";
  ErrorCode["deliveryAddressIsRequired"] = "201";
  ErrorCode["deliveryAddressOfACustomerIsNotFound"] = "202";
  ErrorCode["deliveryAddressIsNotAllowedForACustomer"] = "203";
  ErrorCode["homeDeliveryAddressDoesntMatchZipTree"] = "204";
  ErrorCode["productDimensionCanNotFitToTheShoppingBox"] = "205";
  ErrorCode["productWeightIsOverSmartboxLimit"] = "206";
  ErrorCode["paymentMethodIsNotAllowed"] = "210";
  ErrorCode["creditIsNotAllowedForCustomersOrder"] = "211";
  ErrorCode["credibilityCheckFailed"] = "212";
  ErrorCode["insufficientPrepaymentForPharmacyOrdering"] = "213";
  ErrorCode["cannotOrderSubscriptionBecauseYourLeaderIsNotAuthorized"] = "220";
  ErrorCode["cannotOrderSubscriptionBecauseYourDeliveryIsNotOriflameCertifiedOffice"] = "221";
  ErrorCode["toOrderThisSubscriptionYouNeed"] = "222";
  ErrorCode["placingOrderForTestingShoppingSessionIsNotAllowed"] = "223";
  ErrorCode["placingOrderWithoutFinishedRegistrationIsNotAllowed"] = "224";
  ErrorCode["invalidShoppingOperation"] = "230";
  ErrorCode["meanwhileHaveBeenPlacedOtherOrder"] = "231";
  ErrorCode["meanwhileHaveBeenChangeCataloguesOrRules"] = "232";
  ErrorCode["atpIsDepletedByOtherProcess"] = "233";
  ErrorCode["ticketQuantityIsDepletedByOtherProcess"] = "234";
  ErrorCode["voucherIsDepletedByOtherProcess"] = "235";
  ErrorCode["endConsumerOrderIsAlreadyDroppedOnDifferentOrder"] = "236";
  ErrorCode["servicesAlreadyDroppedOnDifferentOrder"] = "237";
  ErrorCode["financeAccountWasAlreadyConsumed"] = "238";
  ErrorCode["atLeastOneProductMustBeOrdered"] = "240";
  ErrorCode["underOrderAmountLimit"] = "241";
  ErrorCode["unauthorizedAccess"] = "299";
  ErrorCode["currentActionIsDisabledDuringMaintenance"] = "322";
  return ErrorCode;
}({});
const ErrorCodeTranslationMap = exports.ErrorCodeTranslationMap = {
  [ErrorCode.deliveryChannelIsNotAllowedForACustomer]: _TranslationKey.TranslationKey.deliveryChannelIsNotAllowedForACustomer,
  [ErrorCode.deliveryAddressIsRequired]: _TranslationKey.TranslationKey.deliveryAddressIsRequired,
  [ErrorCode.deliveryAddressOfACustomerIsNotFound]: _TranslationKey.TranslationKey.deliveryAddressOfACustomerIsNotFound,
  [ErrorCode.deliveryAddressIsNotAllowedForACustomer]: _TranslationKey.TranslationKey.deliveryAddressIsNotAllowedForACustomer,
  [ErrorCode.homeDeliveryAddressDoesntMatchZipTree]: _TranslationKey.TranslationKey.homeDeliveryAddressDoesntMatchZipTree,
  [ErrorCode.productDimensionCanNotFitToTheShoppingBox]: _TranslationKey.TranslationKey.productDimensionCanNotFitToTheShoppingBox,
  [ErrorCode.productWeightIsOverSmartboxLimit]: _TranslationKey.TranslationKey.productWeightIsOverSmartboxLimit,
  [ErrorCode.paymentMethodIsNotAllowed]: _TranslationKey.TranslationKey.paymentMethodIsNotAllowed,
  [ErrorCode.creditIsNotAllowedForCustomersOrder]: _TranslationKey.TranslationKey.creditIsNotAllowedForCustomersOrder,
  [ErrorCode.credibilityCheckFailed]: _TranslationKey.TranslationKey.credibilityCheckFailed,
  [ErrorCode.insufficientPrepaymentForPharmacyOrdering]: _TranslationKey.TranslationKey.insufficientPrepaymentForPharmacyOrdering,
  [ErrorCode.cannotOrderSubscriptionBecauseYourLeaderIsNotAuthorized]: _TranslationKey.TranslationKey.cannotOrderSubscriptionBecauseYourLeaderIsNotAuthorized,
  [ErrorCode.cannotOrderSubscriptionBecauseYourDeliveryIsNotOriflameCertifiedOffice]: _TranslationKey.TranslationKey.cannotOrderSubscriptionBecauseYourDeliveryIsNotOriflameCertifiedOffice,
  [ErrorCode.toOrderThisSubscriptionYouNeed]: _TranslationKey.TranslationKey.toOrderThisSubscriptionYouNeed,
  [ErrorCode.placingOrderForTestingShoppingSessionIsNotAllowed]: _TranslationKey.TranslationKey.placingOrderForTestingShoppingSessionIsNotAllowed,
  [ErrorCode.placingOrderWithoutFinishedRegistrationIsNotAllowed]: _TranslationKey.TranslationKey.placingOrderWithoutFinishedRegistrationIsNotAllowed,
  [ErrorCode.invalidShoppingOperation]: _TranslationKey.TranslationKey.invalidShoppingOperation,
  [ErrorCode.meanwhileHaveBeenPlacedOtherOrder]: _TranslationKey.TranslationKey.meanwhileHaveBeenPlacedOtherOrder,
  [ErrorCode.meanwhileHaveBeenChangeCataloguesOrRules]: _TranslationKey.TranslationKey.meanwhileHaveBeenChangeCataloguesOrRules,
  [ErrorCode.atpIsDepletedByOtherProcess]: _TranslationKey.TranslationKey.atpIsDepletedByOtherProcess,
  [ErrorCode.ticketQuantityIsDepletedByOtherProcess]: _TranslationKey.TranslationKey.ticketQuantityIsDepletedByOtherProcess,
  [ErrorCode.voucherIsDepletedByOtherProcess]: _TranslationKey.TranslationKey.voucherIsDepletedByOtherProcess,
  [ErrorCode.endConsumerOrderIsAlreadyDroppedOnDifferentOrder]: _TranslationKey.TranslationKey.endConsumerOrderIsAlreadyDroppedOnDifferentOrder,
  [ErrorCode.servicesAlreadyDroppedOnDifferentOrder]: _TranslationKey.TranslationKey.servicesAlreadyDroppedOnDifferentOrder,
  [ErrorCode.financeAccountWasAlreadyConsumed]: _TranslationKey.TranslationKey.financeAccountWasAlreadyConsumed,
  [ErrorCode.atLeastOneProductMustBeOrdered]: _TranslationKey.TranslationKey.atLeastOneProductMustBeOrdered,
  [ErrorCode.underOrderAmountLimit]: _TranslationKey.TranslationKey.underOrderAmountLimit,
  [ErrorCode.unauthorizedAccess]: _TranslationKey.TranslationKey.unauthorizedAccess,
  [ErrorCode.currentActionIsDisabledDuringMaintenance]: _TranslationKey.TranslationKey.currentActionIsDisabledDuringMaintenance
};